import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';

export interface TimestampFilter {
    (date: Date | number | string, format?: string): string;
}

function timestampFilter(
    $filter: ng.IFilterService,
    DATES,
    utilService: UtilService
): TimestampFilter {
    return function (
        date: number | string,
        format: string = DATES.DATETIME_DEFAULT
    ): string {
        return ($filter('date') as ng.IFilterDate)(
            date,
            format,
            utilService.isCentralEuropeanSummerTime(new Date(date))
                ? '+0200'
                : '+0100'
        );
    };
}

angular.module('app').filter('pkpTimestamp', timestampFilter);
